import { FileEntriesDownloadDto, ProjectStructureTemplateDownloadDto, ProjectStructureTemplateEntry } from 'collaboration-service';
import _ from 'lodash';
import * as React from 'react';
import { useImgI18N } from 'services/ImgI18N';
import { CMSSC as T } from './CMSSC';


interface CMSTemplatePreviewProps {
    template?: ProjectStructureTemplateDownloadDto;
    directories?: FileEntriesDownloadDto[];
    sidebarView?: boolean;
    noBgColor?: boolean;
    resetFontSize?: boolean;
}

const CMSTemplatePreview = (p: CMSTemplatePreviewProps) => {
    const { t } = useImgI18N("cms");
    const { template, directories, sidebarView, noBgColor, resetFontSize } = p;

    const count = (directories?: ProjectStructureTemplateEntry[]): number => {
        let total = directories?.length ?? 0;
        _.forEach(directories, d => {
            const subDirs = count(d.children);
            total += subDirs
        });
        return total;
    };


    const struct = React.useMemo(() => {
        const stc = (cur: ProjectStructureTemplateEntry) => {
            return (
                <div key={cur.name}>
                    <li>
                        {cur.children && cur.children.length > 0 ?
                            <div>&#128449;</div> :
                            <div>&#128448;</div>
                        }
                        {cur.name}
                    </li>
                    {cur.children && cur.children.length > 0 &&
                        <ul>
                            {_.map(cur.children, c => stc(c))}
                        </ul>
                    }
                </div>
            );
        };
        const st = (cur: ProjectStructureTemplateDownloadDto) => {
            return (<div key={cur.id}>
                <T.SidbarPreviewContainer
                    sidebarView={sidebarView ?? false}
                    resetFontSize={resetFontSize === true ? true : false}
                >
                    {cur.entries.length > 0 ?
                        <div style={{ float: "left", width: 25 }}>&#128449;</div> :
                        <div style={{ float: "left", width: 25 }}>&#128448;</div>
                    }
                    {cur.name}
                </T.SidbarPreviewContainer>
                {cur.entries.length > 0 &&
                    <ul>
                        {_.map(cur.entries, c => stc(c))}
                    </ul>
                }
            </div>);
        };
        const loopDirs = (dirs: FileEntriesDownloadDto[]) => {
            return (<div>
                {_.map(dirs, (dir, i) => {
                    return (<div key={i}><li>{dir.name}</li>
                        {dir.directories && dir.directories.length > 0 &&
                            <ul>{loopDirs(dir.directories)}</ul>
                        }
                    </div>);
                })}
            </div>);
        };
        return template ? st(template) : directories ? loopDirs(directories) : <div />;
    }, [template, directories, sidebarView, resetFontSize]);

    const height = sidebarView ? count(template?.entries) * 18 + 35 : count(template?.entries) * 18 + 40;
    return (
        template?.entries ?
            <T.TemplateContainerPreview height={height} sidebarView={sidebarView ?? false} noBgColor={noBgColor ?? false} resetFontSize={resetFontSize === true ? true : false}>
                {!sidebarView &&
                    <T.TemplateContainerPreviewTitle>
                        {t("preview")}
                    </T.TemplateContainerPreviewTitle>
                }
                <T.TemplateContainerPreviewContent sidebarView={sidebarView ?? false} resetFontSize={resetFontSize === true ? true : false}>
                    {struct}
                </T.TemplateContainerPreviewContent>
            </T.TemplateContainerPreview>
            : <div />
    );
}
export default CMSTemplatePreview;